// extracted by mini-css-extract-plugin
export default {"superText":"Sr1bG9","logo":"uIYVQj"};